module.exports = __webpack_public_path__ + "static/img/ding39.c09269b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imges/ding39.png
// module id = Qb4H
// module chunks = 0